import Request from './request'

const Servers_Addresses  = {
  getIPSList (params, callback) {
    Request.get('servers-addresses/index', params).then(callback).catch(this.bad_answer)
  },
  getIPS (id, callback) {
    Request.get('servers-addresses/view/' + id).then(callback).catch(this.bad_answer)
  },
  getAddressesHistory(callback) {
    Request.get('servers-addresses/history').then(callback).catch(this.bad_answer)
  },
  createIPS (params, callback) {
    Request.post('servers-addresses/create', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateIPS (id, params, callback) {
    Request.post('servers-addresses/update/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default Servers_Addresses
